<template>
    <footer class="global-footer">
      <ul class="global-footer-link">
        <ul class="footer-links">
          <li v-if="isAcceptedTermOfUse()">
          <router-link to="/home"><a>HOME</a></router-link>
        </li>

        <li v-if="isAcceptedTermOfUse()">
          <router-link to="/faq"><a>よくあるご質問</a></router-link>
        </li>
        <li v-else>
          <router-link to="/preloginfaq"><a>よくあるご質問</a></router-link>
        </li>

        <li>
          <router-link to="/legalNotice"><a>特定商取引に関する表記</a></router-link>
        </li>

        <li>
          <router-link to="/shoppingGuide"><a>ショッピングガイド</a></router-link>
        </li>

        <li>
          <router-link to="/terms"><a>利用規約</a></router-link>
        </li>

        <li>
          <div>
            <a href="https://www.jmec.co.jp/privacy/">個人情報保護方針<img class="external-link-icon" src="../../static/img//アイコン_外部リンク_白.png" /></a>
          </div>            
        </li>

        <li v-if="isAcceptedTermOfUse()">
          <router-link to="/contact"><a>お問い合わせ</a></router-link>
        </li>        
        </ul>        
      </ul>
      
      <div class="global-footer-bottom">
        <p class="global-footer-logo">
          <a :href="`${getFooterLink()}`" target="_blank"><img :src="`@/${getLogoFooterPath()}`" alt="" /></a>
        </p>
        <p class="global-footer-copyright">
          Copyright &copy; {{getCopyright()}}
        </p>
      </div>
    </footer>
</template>

<script>
import authUtil from '../mixins/AuthUtil';
export default {
    name: 'Hooter',
    mixins: [authUtil],
    data() {
        return {
            path: "" 
        }
    },
    methods: {
        isContact () {
            switch (this.path) {
                case '/contact':
                case '/login':
                case '/mailsending':
                case '/reregistration':
                case '/passwordSetting':
                    return false;
                default:
                    return true;
            }
        },
        isFaq () {
            switch (this.path) {
                case '/faq':
                case '/preloginfaq':
                case '/login':                
                case '/mailsending':
                case '/reregistration':
                case '/passwordSetting':
                    return false;
                default:
                    return true;
            }            
        }
    },
    mounted () {
        this.path = this.$route.path;        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Hooter.vue